import { useContext, useEffect, useState } from "react";

export const useShippingDetailFooter = (props) => {
    return {};
};
